import { useEffect, useMemo, useRef } from 'react';
import { useSATConnection } from '../../useSATConnection';
import { useLinkingTracking } from '../orchestration/useLinkingTracking';
import {
	readLinkingFlowAttempt,
	resolveWaitingVariant,
} from './waitingVariants';
import type { WaitingVariant } from './waitingVariants';

// La variante se asigna POR workflowId. Ojo con el timing: la pantalla de
// espera se monta durante 'submitting', ANTES de que el bind responda con el
// workflow_id — una lectura one-shot de storage en el mount resolvía null →
// 'banners' para siempre y la rotación nunca avanzaba. Derivamos del
// workflowId vivo del provider para re-resolver en cuanto el id aterriza
// (milisegundos después); el fallback a storage cubre el resume post-reload.
export const useWaitingExperience = (): { variant: WaitingVariant } => {
	const { trackWaitingVariant } = useLinkingTracking();
	const { workflowId: liveWorkflowId, method } = useSATConnection();

	const assignment = useMemo(() => {
		const attempt = readLinkingFlowAttempt();
		const workflowId = liveWorkflowId ?? attempt.workflowId;
		const resolution = resolveWaitingVariant(workflowId);
		return { ...resolution, workflowId, method };
	}, [liveWorkflowId, method]);

	const trackedWorkflowRef = useRef<string | null>(null);

	useEffect(() => {
		if (!assignment.isNewAssignment || !assignment.workflowId) return;
		if (trackedWorkflowRef.current === assignment.workflowId) return;
		trackedWorkflowRef.current = assignment.workflowId;
		trackWaitingVariant(
			assignment.method,
			assignment.workflowId,
			assignment.variant,
		);
	}, [assignment, trackWaitingVariant]);

	return { variant: assignment.variant };
};
